"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NavigateBack = _ref => {
  let {
    onClick,
    text = "Back"
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    size: "small",
    color: "primary",
    disableElevation: true,
    startIcon: /*#__PURE__*/_react.default.createElement("svg", {
      width: "9",
      height: "16",
      viewBox: "0 0 9 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.20725 7.63392L7.32606 0.225919C7.42788 0.119968 7.54506 0.0668945 7.67744 0.0668945C7.80981 0.0668945 7.927 0.119968 8.02881 0.225919L8.7925 1.02085C8.8945 1.1268 8.94531 1.24855 8.94531 1.3865C8.94531 1.52446 8.8945 1.64621 8.7925 1.75216L2.78894 7.99977L8.7925 14.2476C8.8945 14.3535 8.94531 14.4755 8.94531 14.613C8.94531 14.751 8.8945 14.8729 8.7925 14.9789L8.02881 15.7734C7.927 15.8796 7.80981 15.9323 7.67744 15.9323C7.54506 15.9323 7.42788 15.8794 7.32606 15.7734L0.207437 8.36543C0.105625 8.25948 0.0548124 8.13753 0.0548124 7.99977C0.0548124 7.86202 0.105437 7.74006 0.20725 7.63392V7.63392Z",
      fill: "#4086FF"
    })),
    sx: {
      // "& .MuiButton-startIcon svg": { fontSize: 32 },
      padding: 0,
      fontSize: "16px",
      textTransform: "none",
      fontWeight: "300"
    },
    onClick: onClick
  }, text);
};
var _default = exports.default = NavigateBack;